export default __webpack_public_path__ + "static/media/Skin.7e741acb.pdf";